<app-overlay-loader></app-overlay-loader>
<router-outlet *ngIf="configLoaded"></router-outlet>